import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/views/faqs/index.js");
